//Include Both Helper File with needed methods

import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/fakebackend_helper";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
} from "./reducer";

// initialize relavant method of both Auth





export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};


// export const apiError = () => {
//   try {
//     const response = apiErrorChange("");
//     return response;
//   } catch (error) {
//     return error;
//   }
// };